import { WLGoogleContact } from './wlgooglecontact';

export class GoogleContactResponse {
    public errorCode!: string;
    public errorMessage!: string;
    public contacts: WLGoogleContact[] = [];
}
